<template >
  <banner>
    <div class="grid gap-4 justify-start justify-items-start">
      <div>
        <p class="text-white font-semibold text-base">
          Growth
          <span class="text-primaryLight font-semibold text-base">Simplified</span>
        </p>
        <p class="text-white text-xs">Get credit limit upto ₹25 lakhs</p>
      </div>
      <!-- <p class="text-white flex gap-2 items-start md:items-center text-sm">
        <img
          src="../assets/discount-badge.svg"
          alt="Badge showing percentage discount"
          width="26"
          height="26"
        />
        Upto ₹500 reward points on limit activation
      </p> -->
      <br/>
      <router-link
        :to="{ name: 'Signup' }"
        class="btn btn--normal md:h-10 w-full font-semibold btn--white whitespace-nowrap"
      >Apply Now</router-link>
    </div>
  </banner>
</template>
<script>
import Banner from './Banner.vue';

export default {
  name: 'Apply  NowCard',
  components: {
    Banner,
  },
};
</script>
